export const URLSERVICIOS = 'https://nebosystem.com/servicios/'